import { ReactComponent as OneFour } from '../../../src/assets/ADR/1.4.svg';
import { ReactComponent as OneFive } from '../../../src/assets/ADR/1.5.svg';
import { ReactComponent as OneSix } from '../../../src/assets/ADR/1.6.svg';
import { ReactComponent as One } from '../../../src/assets/ADR/1.svg';
import { ReactComponent as TwoOne } from '../../../src/assets/ADR/2.1.svg';
import { ReactComponent as TwoTwo } from '../../../src/assets/ADR/2.2.svg';
import { ReactComponent as TwoThree } from '../../../src/assets/ADR/2.3.svg';
import { ReactComponent as Three } from '../../../src/assets/ADR/3.svg';
import { ReactComponent as FourOne } from '../../../src/assets/ADR/4.1.svg';
import { ReactComponent as FourTwo } from '../../../src/assets/ADR/4.2.svg';
import { ReactComponent as FourThree } from '../../../src/assets/ADR/4.3.svg';
import { ReactComponent as FiveOne } from '../../../src/assets/ADR/5.1.svg';
import { ReactComponent as FiveTwo } from '../../../src/assets/ADR/5.2.svg';
import { ReactComponent as SixOne } from '../../../src/assets/ADR/6.1.svg';
import { ReactComponent as SixTwo } from '../../../src/assets/ADR/6.2.svg';
import { ReactComponent as Eight } from '../../../src/assets/ADR/8.svg';
import { ReactComponent as Nine } from '../../../src/assets/ADR/9.svg';
import { ReactComponent as NineA } from '../../../src/assets/ADR/9A.svg';
import { ReactComponent as KV } from '../../../src/assets/ADR/kv.svg';
import { ReactComponent as LQ } from '../../../src/assets/ADR/lq.svg';

import { DangerousGoodsItem } from "../../graphql/generated/graphql";

const pictogramMap: Record<string, React.FunctionComponent<React.SVGProps<SVGSVGElement>>> = {
  "lq": LQ,
  "9A": NineA,
  "kv": KV,
  "8": Eight,
  "9": Nine,
  "6.2": SixTwo,
  "6.1": SixOne,
  "5.2": FiveTwo,
  "5.1": FiveOne,
  "4.2": FourTwo,
  "4.3": FourThree,
  "2.3": TwoThree,
  "3": Three,
  "4.1": FourOne,
  "2.1": TwoOne,
  "2.2": TwoTwo,
  "1": One,
  "1.6": OneSix,
  "1.5": OneFive,
  "1.4": OneFour,
};

function getPictogramCodes(item: DangerousGoodsItem): string[]
{
  let codes: string[] = [];
  if(item.ADRMarkingCode1) codes.push(item.ADRMarkingCode1);
  if(item.ADRMarkingCode2) codes.push(item.ADRMarkingCode2);
  if(item.ADRMarkingCode3) codes.push(item.ADRMarkingCode3);

  if(item.EnvironmentallyHazardous) codes.push("kv");
  if(item.DangerousGoodsTypeName === 'LQ')
  {
    codes = ["lq"];
  }
  return codes.filter(code => !!code);
}

export function DangerousGoodsPictograms({ item }: { item: DangerousGoodsItem })
{
  const codes = getPictogramCodes(item);

  return (
    <div>
      {codes.map(code =>
      {
        const Pictogram = pictogramMap[code];
        return Pictogram ? <Pictogram key={code} /> : null;
      })}
    </div>
  );
}

